"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Avatar = require("./Avatar.styles");

var _icons = require("../../assets/icons");

var _util = require("../../util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Container = (0, _base["default"])("div", {
  target: "eoqgd571",
  label: "Container"
})(_Avatar.styles.base, ";");
var NotAvatar = ( /*#__PURE__*/0, _base["default"])(Container, {
  target: "eoqgd570",
  label: "NotAvatar"
})(_Avatar.styles.notAvatar, ";");

var Avatar = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var avatar = _ref.avatar,
      userName = _ref.userName,
      className = _ref.className,
      size = _ref.size,
      onClick = _ref.onClick,
      borderRadius = _ref.borderRadius;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hasError = _useState2[0],
      setHasError = _useState2[1];

  var handleError = (0, _react.useCallback)(function (e) {
    setHasError(e.type === 'error');
  }, []);
  (0, _react.useEffect)(function () {
    if (!avatar) {
      setHasError(true);
      return undefined;
    }

    var image = new Image();
    image.src = avatar;
    image.addEventListener('error', handleError);
    image.addEventListener('load', handleError);
    return function () {
      // Remove events when the component is unmounted
      image.removeEventListener('error', handleError);
      image.removeEventListener('load', handleError);
    };
  }, [avatar, handleError]);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    (0, _util.handleEnter)(e, onClick);
  }, [onClick]);
  var commonProps = (0, _react.useMemo)(function () {
    var props = {
      className: className,
      ref: ref,
      borderRadius: borderRadius,
      size: size
    };
    if (typeof onClick !== 'function') return props;
    return _objectSpread(_objectSpread({}, props), {}, {
      onClick: onClick,
      onKeyDown: handleKeyDown,
      tabIndex: 0,
      role: 'link'
    });
  }, [borderRadius, className, handleKeyDown, onClick, ref, size]);

  if (hasError && userName) {
    return (0, _jsxRuntime.jsx)(NotAvatar, _objectSpread(_objectSpread({}, commonProps), {}, {
      children: userName[0]
    }));
  }

  return (0, _jsxRuntime.jsx)(Container, _objectSpread(_objectSpread({
    style: hasError === false ? {
      backgroundImage: "url(".concat(avatar, ")")
    } : {}
  }, commonProps), {}, {
    children: hasError && (0, _jsxRuntime.jsx)(_icons.User, {})
  }));
});

Avatar.propTypes = {
  avatar: _propTypes.string,
  userName: _propTypes.string,
  className: _propTypes.string,
  size: (0, _propTypes.oneOf)(['big', 'small', 'xl']),
  onClick: _propTypes.func,
  borderRadius: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
};
Avatar.defaultProps = {
  avatar: undefined,
  userName: undefined,
  className: undefined,
  size: 'big',
  onClick: undefined,
  borderRadius: '50%'
};
Avatar.displayName = 'Avatar';
var _default = Avatar;
exports["default"] = _default;
//# sourceMappingURL=Avatar.js.map